<ng-template #pontoCritico>
  <div class="info-page">
    <h3>Ponto Crítico</h3>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()" *ngIf="!isLoading">
    <div class="form-group row">
      <label class="col-sm-6 col-form-label">Ponto Crítico/Risco<sup class="text-danger ms-2">*</sup></label>
      <div class="col-sm-8">
        <textarea id="description" class="form-control" rows="4" formControlName="description" required maxlength="300"></textarea>
        <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-12 col-form-label">Status<sup class="text-danger ms-2">*</sup></label>
      <div class="col-sm-6">
        <ng-select id="critical_stat_id" class="ng-select-alternative" [items]="statusList" bindLabel="name" bindValue="id" placeholder="Selecione" formControlName="critical_stat_id"></ng-select>
        <app-field-message [field]="fieldMessageRequired('critical_stat_id')" [erros]="fieldErros('critical_stat_id')"></app-field-message>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-12 col-form-label">Tipo</label>
      <div class="col-sm-6">
        <ng-select id="critical_type_id" class="ng-select-alternative" [items]="tiposList" bindLabel="name" bindValue="id" placeholder="Selecione" formControlName="critical_type_id"></ng-select>
        <app-field-message [field]="fieldMessageRequired('critical_type_id')" [erros]="fieldErros('critical_type_id')"></app-field-message>
      </div>
    </div>

    <div *ngIf="!idPgIndicador" class="form-group row">
      <label class="col-sm-12 col-form-label">Probabilidade<sup class="text-danger ms-2">*</sup></label>
      <div class="col-sm-6">
        <ng-select id="critical_probability_id" class="ng-select-alternative" [items]="probabilidadesList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="critical_probability_id"></ng-select>
        <app-field-message [field]="fieldMessageRequired('critical_probability_id')" [erros]="fieldErros('critical_probability_id')"></app-field-message>
      </div>
    </div>

    <div *ngIf="!idPgIndicador" class="form-group row">
      <label class="col-sm-12 col-form-label">Impacto<sup class="text-danger ms-2">*</sup></label>
      <div class="col-sm-6">
        <ng-select id="critical_impact_id" class="ng-select-alternative" [items]="impactoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="critical_impact_id"></ng-select>
        <app-field-message [field]="fieldMessageRequired('critical_impact_id')" [erros]="fieldErros('critical_impact_id')"></app-field-message>
      </div>
    </div>

    <!-- <div class="form-group row" *ngIf="entity">
          <label class="col-sm-12 col-form-label">Ponto crítico sensível</label>
          <div class="col-sm-6">
            <select class="form-select m-b" id="sensitive_id" formControlName="sensitive_id">
              <option *ngFor="let s of sensivelList" [value]="s.id">{{ s.label }}</option>
            </select>
            <app-field-message [field]="fieldMessageRequired('sensitive_id')" [erros]="fieldErros('sensitive_id')"></app-field-message>
          </div>
        </div> -->

    <div *ngIf="!idPgIndicador" class="form-group row">
      <label class="col-sm-12 col-form-label">Responsável titular<sup class="text-danger ms-2">*</sup></label>
      <div class="col-sm-6">
        <ng-select id="manager_main" class="ng-select-alternative" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager_main"></ng-select>
        <app-field-message [field]="fieldMessageRequired('manager_main')" [erros]="fieldErros('manager_main')"></app-field-message>
      </div>
    </div>

    <div *ngIf="!idPgIndicador" class="form-group row">
      <label class="col-sm-12 col-form-label">Responsável adjunto</label>
      <div class="col-sm-6">
        <ng-select id="manager_adjunct" class="ng-select-alternative" [multiple]="true" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager_adjunct"></ng-select>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
        <button class="btn btn-primary" type="submit" [disabled]="this.entity && !this.entity.canEdit">Salvar</button>
      </div>
    </div>
  </form>
</ng-template>

<div *ngIf="!pgIndicador">
  <ng-container *ngTemplateOutlet="pontoCritico"></ng-container>
</div>

<div class="wrapper wrapper-content animated fadeIn" *ngIf="pgIndicador">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <ng-container *ngTemplateOutlet="pontoCritico"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>
